import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./Navbar.css";
import { Navbar, Nav, Container } from "react-bootstrap";
import logo from '../../assets/Images/home/Filtrix.png';
import menu from '../../assets/Images/svg/menu.svg';
import search from '../../assets/Images/svg/search.svg';
import account from '../../assets/Images/svg/account.svg';

function NavigationBar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const scrollThreshold = 100;

      setIsScrolled(scrollPosition > scrollThreshold);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Function to check if the current path matches the link
  const isActive = (path) => window.location.pathname === path;

  const isProductDetailsPage = location.pathname === "/productdetails";

  return (
    <Navbar
      expand="lg"
      className={`website-nav ${isScrolled ? "website-nav-scrolled" : ""} ${isMenuOpen ? "menu-open" : ""} ${isProductDetailsPage ? "product-details" : ""}`}
      fixed="top"
    >
      <Container>
        <Navbar.Brand href="/home">
          <img className="menu-icon d-none" src={menu} onClick={handleToggle} alt="Menu Icon" />
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            onClick={(e) => {
              e.preventDefault();
              handleToggle();
            }}
          />
          <img className="nav-logo" src={logo} alt="Logo" />
        </Navbar.Brand>

        <Navbar.Collapse id="basic-navbar-nav" className={`${isMenuOpen ? "show" : ""}`}>
          <Nav className="mx-auto">
            <Nav.Link href="/home" className={isActive("/home") ? "active" : ""}>Home</Nav.Link>
            <Nav.Link href="/products" className={isActive("/products") ? "active" : ""}>Hardware Solutions</Nav.Link>
            <Nav.Link href="/brands" className={isActive("/brands") ? "active" : ""}>Brands</Nav.Link>
            <Nav.Link href="/services" className={isActive("/services") ? "active" : ""}>Services</Nav.Link>
            <Nav.Link href="/about" className={isActive("/about") ? "active" : ""}>About Us</Nav.Link>
            <Nav.Link href="/contact" className={isActive("/contact") ? "active" : ""}>Contact Us</Nav.Link>
          </Nav>
          
          {/* Account icons inside Navbar.Collapse for small screens */}
          {/* <div className="account-div d-lg-none">
            <img src={search} alt="Search" />
            <img src={account} alt="Account" />
          </div> */}
        </Navbar.Collapse>

        {/* Account icons outside of collapse for large screens */}
        {/* <div className="account-div d-none d-lg-flex">
          <img src={search} alt="Search" />
          <img src={account} alt="Account" />
        </div> */}
      </Container>
    </Navbar>
  );
}

export default NavigationBar;
